import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ProjectCard = ({ project }) => {
  const sliderSettings = {
    
    dots: true, // Show navigation dots
    infinite: true, // Infinite scrolling
    speed: 500, // Transition speed (ms)
    slidesToShow: 1, // Show only one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    arrows: false, // Show navigation arrows
    pauseOnHover: true
  };

  return (
    <div className="max-w-sm rounded overflow-hidden shadow-lg bg-white dark:bg-[#0b111b] p-4 rounded-xl">
      <div className="rounded-lg ">
        <Slider {...sliderSettings}>
          {project.imageUrl.map((image, index) => (
            <img
              key={index}
              className="w-full rounded-lg"
              src={image}
              alt={`${project.title} - ${index + 1}`}
            />
          ))}
        </Slider>
      </div>
      <div className="px-2 py-4">
        <div className="font-bold text-xl mb-2">{project.title}</div>
        <p className="text-gray-800 dark:text-gray-200  text-xs">{project.description}</p>
        <p className="text-gray-800 dark:text-gray-200 text-xs mt-2">
          <span className="font-semibold text-red-600">Tech Stack: </span>
          {project.techStack}
        </p>
      </div>
      <div className="px-2 py-4 flex justify-between text-xs">
        <a
          href={project.liveLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:text-blue-700"
        >
          Live Demo
        </a>
          {project.Microservice_Based  && <a
          href={project.Microservice_Based}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:text-blue-700"
        >
         Microservice Architecture
        </a>}
        <a
          href={project.githubLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:text-blue-700"
        >
          GitHub Repo
        </a>
        {project.githubbLink && (
          <a
            href={project.githubbLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:text-blue-700"
          >
            Backend GitHub Repo
          </a>
        )}
      </div>
    </div>
  );
};
 const projectsss = [
    {
      title: 'ProLearning - AI-Driven LMS',
      description:
        'AI MERN-stack learning management system enabling teachers to create physical tests linked to topics, automatically generate AI-powered recommendations and Q&A, and recommend personalized learning plans based on student performance.',
      techStack: 'MERN, WebSocket, AI APIs (Gemini), Redux',
      imageUrl: ['/project1.png','/project1(2).png','/project1(3).png'],
      liveLink: 'https://prolearning-mu.vercel.app',
      githubLink: 'https://github.com/nilu-ai/Prolearning_Frontend',
      githubbLink: 'https://github.com/nilu-ai/prolearning-backend',
    },
    {
      title: 'Sign Language Learning Platform',
      description:
        'This platform is used for normal people to learn sign language so they can easily communicate with Deaf & mute people. The model is trained on Hand Sign Dataset using CNN. The front-end of the platform was built using Next.js.',
      techStack: 'Next.js, Python, CNN, JavaScript',
      imageUrl: ['/project2.png','/project2(2).png'],
      liveLink: 'https://genuine-druid-0c314f.netlify.app/', // Add live link here
      githubLink: 'https://github.com/NileshRaut-code/SLLP',
    },
  
    {
      title: 'Lonar Marketplace Backend',
      description:
        'Built a dynamic marketplace backend with user roles (User, Seller, Admin). Sellers add products & manage shop profiles, while Admin supervises all roles. Users enjoy easy product viewing, purchasing, & cart functionality.',
      techStack: 'Node, Express JS, MongoDB, JWT, Redux,Razor Payment (For Payment Gateway)',
      imageUrl: ['/project3.png','/project3(2).png','/project3(3).png','/project3(4).png','/project3(5).png'],
      liveLink: 'https://lonar-market-frontend.vercel.app/', // Add live link here
      githubLink: 'https://github.com/NileshRaut-code/Lonar_Market_Frontend',
      githubbLink: 'https://github.com/NileshRaut-code/Lonar-markate-place-backend',
      Microservice_Based:"https://github.com/NileshRaut-code/Lonar_Backend_Microservices",
    },
    {
      title: 'Blog App',
      description:
        'Created a blog app using React.js (frontend) and Express.js (backend). Only logged-in users can create/edit/delete posts, while all users can view posts.',
      techStack: 'Node, Express JS, MongoDB, JWT, React JS',
      imageUrl: ['/project4.png','/project4(1).png'],
      liveLink: 'https://blog.technilesh.com', // Add frontend live link here
      githubLink: 'https://github.com/NileshRaut-code/Blog_FrontEnd',
      githubbLink: 'https://github.com/NileshRaut-code/Blog_Backend',
    },
    {
      title: 'LeetCode Clone App',
      description:
        'Developed a LeetCode-inspired application for coding practice using React.js (frontend) and Express.js (backend). The app allows users to log in, solve coding problems, and track their progress. Users can create, edit, and delete problems, while others can view and attempt them.',
      techStack: 'React.js, Node.js, Express.js, MongoDB, JWT',
      imageUrl: ['/leetcode.png','/leetcode1.png','/leetcode2.png'],
      liveLink: 'https://leetcode-clone-orpin-nine.vercel.app', // Add frontend live link here
      githubLink: 'https://github.com/NileshRaut-code/Leetcode_Clone',
      githubbLink: 'https://github.com/NileshRaut-code/Backend_Leetcode_clone',
    },
    {
      title: 'Product Tracking',
      description:
        'Built a real-time product tracking system using React.js and WebSocket for live updates. The application allows users to track delivery status and location on an interactive map. Tailwind CSS is used to enhance the UI for a modern and responsive design.',
      techStack: 'React.js, WebSocket, Tailwind CSS',
      imageUrl: ['/project5(1).png','/project5(2).png'],
      liveLink: 'https://product-tracking-ruddy.vercel.app/', // Add frontend live link here
      githubLink: 'https://github.com/NileshRaut-code/Product_Tracking',
      githubbLink: 'https://github.com/NileshRaut-code/Backend_Product_Tracking',
    },
       {
      title: 'Scalable Chat App',
     description:'Built a real-time chat application using a Pub/Sub architecture to enable communication across multiple servers. Implemented WebSockets to ensure real-time messaging even when users are connected to different servers.',
        techStack: 'Node js , Express js , WebSocket , Redis (Pub/Sub , Datastore)',
      imageUrl: ['/project6(1).png','/project6(2).png','/project6(3).png'],
      liveLink: 'https://chat-app-production-411f.up.railway.app', // Add frontend live link here
      githubLink: 'https://github.com/NileshRaut-code/Chat-app',
     
    },

  ];
const Projects = () => {

  
 
  

  return (
    <div
    id="about"
    className="min-h-screen flex flex-col  items-center justify-center gap-16 px-6 lg:px-16 bg-[#edf2f8] dark:bg-gray-900 text-black dark:text-white  mb-4"
  >
    <h1 className='text-3xl font-bold mt-20 text-center'>My Creative <span className='text-red-500 '>Project</span> Section <span className='text-red-500 '>Experience</span></h1>

    <div className='	'>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-16 max-w-[80vw] mx-auto">
  {projectsss.map((project, index) => (
    <ProjectCard key={index} project={project} />
  ))}
</div>




      {/* <div>1</div>
      <div>1</div>
      <div>1</div> */}
    </div>

</div>
  )
}

export default Projects
